/**
 * Registry of report export functions.
 * Each key must match the `downloadFunctionName` value in the reportList constant.
 * To add a new export handler, add an entry here and reference its key
 * in the corresponding reportList object in Constants.ts.
 */

import AxiosClient from './AxiosClient';
import { handleSuccess, handleError } from './HttpUtil';
import { EAction } from '../data/Constants';
import { AppStore } from '../store';

/**
 * Fetches the descope list report as a binary file and triggers a download
 * via {@link handleSuccess}. Dispatches an error notification on failure.
 */
const exportDescopeList = (): void => {
  AxiosClient.get('/report/v1/descopelist/txt', { responseType: 'arraybuffer' })
    .then((response) => {
      handleSuccess(response, EAction.Download);
    })
    .catch((err) => {
      handleError(AppStore.dispatch, err, EAction.Download);
    });
};

/**
 * Fetches the extract for COE report as a binary file and triggers a download
 * via {@link handleSuccess}. Dispatches an error notification on failure.
 */
const exportExtractForCoe = (): void => {
  AxiosClient.get('/report/v1/coe', { responseType: 'arraybuffer' })
    .then((response) => {
      handleSuccess(response, EAction.Download);
    })
    .catch((err) => {
      handleError(AppStore.dispatch, err, EAction.Download);
    });
};

/**
 * Maps each report's `downloadFunctionName` key to its corresponding export handler.
 * Add new export functions here and reference their key in `Constants.ts` `reportList`.
 */
export const reportDownloadRegistry: Record<string, () => void> = {
  exportDescopeList,
  exportExtractForCoe,
};
